import { Component, Input, OnChanges, OnInit } from "@angular/core";

@Component({
  selector: 'avatar',
  template: `
  <div class="avatar"
       [style.background-color]=[background]
       [style.width]="props.size"
       [style.line-height]="props.lineheight"
       [style.height]="props.size"
       [style.font-size]="props.fontSize"
       [style.border-radius]="props.borderradius"
       [style.text-align]="props.textalign">
    <span [style.color]="fontColor">{{letter}}</span>
  </div>`,
  styles  : ['.avatar {text-align : center;overflow   : auto;}']
})

export class AvatarComponent implements OnInit, OnChanges {

  //@Input() email : string;
  @Input('name') name: string ;
  @Input('size') size = 100;
  @Input('background') background: string;
  @Input('displayType') displayType = 'none';
  @Input('letter') letter = '?';

  gravatarUrl: string;
  displayImage = false;
  fontSize = 49;
  fontColor = '#FFFFFF';
  props: object = null;

  constructor() {
  }

  getLetter(): void {
    if (this.name && this.name.length) {
      const nameInitials = this.name.match(/\b(\w)/g);
      const nameLetters = nameInitials.slice(0, 3).join('');
      this.letter = nameLetters.toUpperCase();
    }
  }


  ngOnInit() {
    this.fontSize = (39 * this.size) / 100;
    this.props = {
      size      : `${this.size}px`,
      lineheight: `${this.size}px`,
   //   background: this.background,
      fontSize  : `${this.fontSize}px`
    };

    switch (this.displayType) {
      case 'square':
        this.props['borderradius'] = '1%';
        break;
      case 'rounded':
        this.props['borderradius'] = '25%';
        break;
      case 'circle':
        this.props['borderradius'] = '50%';
        break;
      default:
        this.props['borderradius'] = '0';
    }
    this.getLetter();
  }

  ngOnChanges(email) {
      this.getLetter();
  }

}



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/shared/avatar/avatar.component.ts